import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { EyeIcon, PencilIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

import store, {
    setIsHistoryModalOpened,
    setSelectedPaymentMethods,
    setSelectedHistoryPaymentMethods,
    setIsInputUpdated,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setIsLoading,
} from "../store";
import { store as storeData } from "@components/VerticalLayout/store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import { ArchivedValidationModal } from "@components/Common/ArchivedValidationModal";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import { generalConfigStore } from "@store";

import {
    fetchPaysIfNeeded,
    handleArchivePaymentMethod,
    handleConsultPaymentMethod,
    handleOnClickEvent,
    handlePaymentMethodDeletion,
    handlePaymentMethodHistory,
    handleStatePaymentMethodActivation,
    handleTrashButtonClicked,
    handleUpdatePaymentMethodClick,
} from "./hooks";
import { useDispatch, useSelector } from "react-redux";
import { useFetchGlobal } from "../../../../api/hooks";

type CustomIconsType = {
    selectedRows: any;
    selectedRowData: any;
    setPaymentMethod: Function;
    userData: {
        userId: number;
        shopId: number | string;
        franchiseId: string;
        operatorID: string;
        uuidUser: any;
    };
    setIsAddChoiceClicked: Function;
    setIsModalConfirmationOpened: Function;
    isModalConfirmationOpened: boolean;
    setSelectedRows: Function;
    isArchivedPaymentMethodsClicked: boolean;
    setIsConsult: Function;
};

export function CustomIcons({
    selectedRowData,
    setPaymentMethod,
    userData,
    setIsAddChoiceClicked,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    setSelectedRows,
    isArchivedPaymentMethodsClicked,
    setIsConsult,
}: CustomIconsType) {
    const { t } = useTranslation();
    const { oneShop, shopID, operatorID, userID, franchiseID } = useSnapshot(
        storeData
    );
    const {
        isInputUpdated,
        isArchiveModalOpened,
        isHistoryModalOpened,
        shopsPaymentMethodsData,
        listFranchiseArchived,
        isActionsClicked,
        isEdited,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const listOfCountry = useSelector((state: any) => state.global.pays);
    const dispatch = useDispatch();
    const { fetchGlobal } = useFetchGlobal();
    const [choiceState, setPaymentMethodState] = React.useState<boolean>(
        selectedRowData.selectedRow.isActive
    );
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    const [
        isArchivedValidationModalOpened,
        setIsArchivedValidationModalOpened,
    ] = React.useState<boolean>(false);
    const shopId = oneShop ? shopID : 0;
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    React.useEffect(() => {
        if (isValidateClicked) {
            handleArchivePaymentMethod(
                selectedRowData.selectedRow,
                selectedRowData,
                isArchiveModalOpened,
                userData,
                operatorID,
                uuidUser,
                setIsArchivedValidationModalOpened,
                itemsDisable,
                setIsValidateClicked,
                fetchGlobal
            );
        }
        // eslint-disable-next-line
    }, [isValidateClicked, selectedRowData]);

    return (
        <React.Fragment>
            <div className="d-flex justify-content-around">
                {modify === false ? (
                    <Tooltip title={t("To consult")}>
                        <div>
                            {" "}
                            <ConsultSvgIcon
                                className="pointer__clz afa_icn_toConsult"
                                height={35}
                                width={35}
                                style={{
                                    cursor: "pointer",
                                    position: "relative",
                                    bottom: "5px",
                                }}
                                fill="black"
                                onClick={() =>
                                    handleConsultPaymentMethod({
                                        isEdited,
                                        isActionsClicked,
                                        setIsActionsClicked,
                                        setActions,
                                        setIsEdited,
                                        clearData,
                                        clearMultiCustomSelectionData,
                                        setPaymentMethod,
                                        selectedRowData,
                                        setIsAddChoiceClicked,
                                        setIsInputUpdated,
                                        isInputUpdated,
                                        setIsConsult,
                                    })
                                }
                            />
                        </div>
                    </Tooltip>
                ) : null}
                {modify === true ? (
                    <>
                        <Tooltip
                            title={
                                isArchivedPaymentMethodsClicked ? "" : t("Edit")
                            }
                        >
                            <div>
                                <PencilIcon
                                    onClick={() => {
                                        fetchPaysIfNeeded(
                                            listOfCountry,
                                            dispatch,
                                            i18nextLng,
                                            fetchGlobal
                                        );
                                        handleUpdatePaymentMethodClick({
                                            isEdited,
                                            isActionsClicked,
                                            setIsActionsClicked,
                                            setActions,
                                            setIsEdited,
                                            clearData,
                                            clearMultiCustomSelectionData,
                                            setPaymentMethod,
                                            selectedRowData,
                                            setIsAddChoiceClicked,
                                            setIsInputUpdated,
                                            isInputUpdated,
                                        });
                                    }}
                                    height={25}
                                    width={25}
                                    style={{ cursor: "pointer" }}
                                    className={`${classnames(
                                        "pointer__clz cmn_icn_FRedit",
                                        {
                                            "not-allowed-icon__clz":
                                                isArchivedPaymentMethodsClicked ||
                                                isLoading,
                                        },
                                        oneShop ? "mr-2" : "ml-3"
                                    )}`}
                                />
                            </div>
                        </Tooltip>
                        {selectedRowData.selectedRow.idShop !== "0" ? (
                            <Tooltip
                                title={
                                    isArchivedPaymentMethodsClicked
                                        ? ""
                                        : choiceState === false
                                        ? t("Activate")
                                        : t("Unactivate")
                                }
                            >
                                <div>
                                    <ReactSwitch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        handleDiameter={26}
                                        offColor="#f7b4b8"
                                        offHandleColor="#E30613"
                                        checked={choiceState}
                                        onChange={(e: boolean) =>
                                            handleStatePaymentMethodActivation({
                                                e,
                                                isEdited,
                                                isActionsClicked,
                                                setIsActionsClicked,
                                                setActions,
                                                setIsEdited,
                                                setIsAddChoiceClicked,
                                                setMessage,
                                                t,
                                                choiceState,
                                                setYesFunction,
                                                setPaymentMethodState,
                                                userData,
                                                selectedRowData,
                                                operatorID,
                                                uuidUser,
                                                itemsDisable,
                                                setActivationDeactivationMessageModalOpened,
                                                setIsLoading,
                                                fetchGlobal,
                                            })
                                        }
                                        onColor="#c2eddd"
                                        onHandleColor="#34C38F"
                                        width={50}
                                        height={20}
                                        className={`${classnames(
                                            "cmn_icn_BTenableDisable",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedPaymentMethodsClicked ||
                                                    isLoading,
                                            },
                                            oneShop ? "mr-2" : "ml-3"
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                        ) : null}

                        {!isArchivedPaymentMethodsClicked ? (
                            <Tooltip title={t("Archive")}>
                                <div>
                                    <TrashIcon
                                        onClick={async () =>
                                            handlePaymentMethodDeletion({
                                                isEdited,
                                                isActionsClicked,
                                                setIsActionsClicked,
                                                setActions,
                                                setIsEdited,
                                                setIsAddChoiceClicked,
                                                setIsLoading,
                                                handleTrashButtonClicked,
                                                selectedRowData,
                                                shopsPaymentMethodsData,
                                                franchiseID,
                                                isArchivedValidationModalOpened,
                                                setIsArchivedValidationModalOpened,
                                                setPaymentMethod,
                                                clearData,
                                                clearMultiCustomSelectionData,
                                                fetchGlobal,
                                            })
                                        }
                                        height={25}
                                        width={25}
                                        fill="red"
                                        style={{ cursor: "pointer" }}
                                        className={`${classnames(
                                            "pointer__clz  cmn_icn_FRarchived",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedPaymentMethodsClicked ||
                                                    isLoading,
                                            },
                                            oneShop ? "mr-2" : "ml-3"
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                        ) : (
                            <Tooltip
                                title={
                                    oneShop &&
                                    listFranchiseArchived.find(
                                        (el: any) =>
                                            el.id ===
                                            selectedRowData.selectedRow.id
                                    ) !== undefined
                                        ? ""
                                        : t("Unarchive")
                                }
                            >
                                <div>
                                    <EyeIcon
                                        height={25}
                                        width={25}
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                            handleOnClickEvent(
                                                setSelectedRows,
                                                selectedRowData,
                                                oneShop,
                                                setIsModalConfirmationOpened,
                                                isModalConfirmationOpened,
                                                shopsPaymentMethodsData,
                                                i18nextLng,
                                                userID,
                                                shopId,
                                                franchiseID,
                                                userData,
                                                operatorID,
                                                uuidUser,
                                                itemsDisable,
                                                fetchGlobal
                                            )
                                        }
                                        className={`${classnames(
                                            "pointer__clz cmn_icn_FRunarchive",
                                            {
                                                "not-allowed-icon__clz":
                                                    (oneShop &&
                                                        listFranchiseArchived.find(
                                                            (el: any) =>
                                                                el.id ===
                                                                selectedRowData
                                                                    .selectedRow
                                                                    .id
                                                        ) !== undefined) ||
                                                    isLoading,
                                            },
                                            oneShop ? "mr-2" : "ml-3"
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                        )}
                    </>
                ) : null}
                <Tooltip title={t("Consult history")}>
                    <div>
                        <TimePastSvgIcon
                            style={{
                                cursor: "pointer",
                            }}
                            className={`${classnames(
                                "pointer__clz  cmn_icn_FRhistory",
                                {
                                    "not-allowed-icon__clz": isLoading,
                                },
                                oneShop ? "mr-2" : "ml-3"
                            )}`}
                            onClick={(e: any) =>
                                handlePaymentMethodHistory({
                                    isEdited,
                                    isActionsClicked,
                                    setIsActionsClicked,
                                    setActions,
                                    setIsEdited,
                                    setIsHistoryModalOpened,
                                    isHistoryModalOpened,
                                    setPaymentMethod,
                                    setIsAddChoiceClicked,
                                    clearData,
                                    clearMultiCustomSelectionData,
                                    setSelectedHistoryPaymentMethods,
                                    setSelectedPaymentMethods,
                                    selectedRowData,
                                })
                            }
                        />
                    </div>
                </Tooltip>
            </div>
            {isArchivedValidationModalOpened ? (
                <ArchivedValidationModal
                    text={t(
                        "Attention, this (these) payment method can be used by other modules.\n\nDo you want to confirm the archiving of the selected of payment method(s)"
                    )}
                    isModalOpened={isArchivedValidationModalOpened}
                    setIsModalOpened={setIsArchivedValidationModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
        </React.Fragment>
    );
}
